/* Footer — cierre estructural y legal del sitio.
   Estático: sin animaciones de entrada, no compite por atención.
   Solo hovers sutiles (200ms) en links e iconos. */

.footer {
  background: var(--blue-900);
  border-top: 1px solid rgba(255, 255, 255, 0.08);
  color: var(--color-text-inverse);
  padding-block: var(--space-16) var(--space-8);
}

@media (min-width: 768px) {
  .footer {
    padding-block: var(--space-20) var(--space-10);
  }
}

.inner {
  display: flex;
  flex-direction: column;
  gap: var(--space-10);
}

/* ─── Grid principal ────────────────────────────────────
   4 columnas en desktop con la columna de marca más ancha.
   Stack en mobile. */

.grid {
  display: grid;
  grid-template-columns: 1fr;
  gap: var(--space-10);
}

@media (min-width: 640px) {
  .grid {
    grid-template-columns: repeat(2, 1fr);
    gap: var(--space-10) var(--space-8);
  }
}

@media (min-width: 960px) {
  .grid {
    grid-template-columns: 2fr 1fr 1fr;
    gap: var(--space-8);
  }
}

/* ─── Columna de marca ─────────────────────────────────── */

.brandCol {
  display: flex;
  flex-direction: column;
  gap: var(--space-4);
  max-width: 340px;
}

.brand {
  display: inline-flex;
  align-items: baseline;
  gap: 4px;
  color: var(--color-text-inverse);
  text-decoration: none;
  border-radius: var(--radius-sm);
  transition: opacity var(--duration-base) var(--ease-standard);
  width: fit-content;
}

.brand:hover {
  opacity: 0.7;
}

.brandText {
  font-family: var(--font-heading);
  font-weight: 800;
  font-size: var(--text-2xl);
  letter-spacing: -0.02em;
  line-height: 1;
}

.brandDot {
  width: 7px;
  height: 7px;
  border-radius: var(--radius-full);
  background: var(--color-accent);
  transform: translateY(-1px);
}

.pitch {
  font-family: var(--font-body);
  font-size: var(--text-sm);
  line-height: 1.55;
  color: rgba(255, 255, 255, 0.72);
  margin: 0;
  max-width: 32ch;
}

/* ─── Redes sociales ─────────────────────────────────────
   Botones cuadrados pequeños. Hover: scale + color de marca. */

.social {
  display: flex;
  gap: var(--space-2);
  list-style: none;
  padding: 0;
  margin: var(--space-2) 0 0;
}

.socialLink {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 40px;
  height: 40px;
  border-radius: var(--radius-full);
  background: rgba(255, 255, 255, 0.06);
  color: rgba(255, 255, 255, 0.78);
  text-decoration: none;
  border: 1px solid rgba(255, 255, 255, 0.12);
  transition:
    color var(--duration-base) var(--ease-standard),
    background-color var(--duration-base) var(--ease-standard),
    transform var(--duration-base) var(--ease-standard),
    border-color var(--duration-base) var(--ease-standard);
}

.socialLink:hover {
  color: var(--color-text-inverse);
  background: rgba(255, 255, 255, 0.10);
  border-color: var(--color-accent);
  transform: scale(1.1);
}

.socialLink:focus-visible {
  outline: 2px solid var(--color-border-focus);
  outline-offset: 2px;
}

/* ─── Columnas de links ────────────────────────────────── */

.col {
  display: flex;
  flex-direction: column;
  gap: var(--space-4);
}

.colTitle {
  font-family: var(--font-body);
  font-size: var(--text-xs);
  font-weight: 600;
  letter-spacing: 0.12em;
  text-transform: uppercase;
  color: rgba(255, 255, 255, 0.55);
  margin: 0;
}

.list {
  list-style: none;
  padding: 0;
  margin: 0;
  display: flex;
  flex-direction: column;
  gap: var(--space-3);
}

.link {
  font-family: var(--font-body);
  font-size: var(--text-base);
  font-weight: 500;
  color: rgba(255, 255, 255, 0.88);
  text-decoration: none;
  transition: color var(--duration-base) var(--ease-standard);
}

.link:hover {
  color: var(--color-accent);
}

.link:focus-visible {
  outline: 2px solid var(--color-border-focus);
  outline-offset: 2px;
  border-radius: var(--radius-sm);
}

/* ─── Barra inferior ─────────────────────────────────────
   Separada por una línea fina. Copyright a la izquierda,
   "Hecho en Argentina" con bandera a la derecha. */

.bottom {
  display: flex;
  flex-direction: column;
  gap: var(--space-3);
  padding-top: var(--space-6);
  border-top: 1px solid rgba(255, 255, 255, 0.10);
  font-family: var(--font-body);
  font-size: var(--text-xs);
  color: rgba(255, 255, 255, 0.55);
}

@media (min-width: 640px) {
  .bottom {
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    gap: var(--space-4);
  }
}

.copyright,
.madeIn {
  margin: 0;
}

.madeIn {
  display: inline-flex;
  align-items: center;
  gap: var(--space-2);
}

.flag {
  display: block;
  border-radius: 2px;
  box-shadow: 0 0 0 1px rgba(255, 255, 255, 0.20) inset;
}

/* ─── Reduced motion ────────────────────────────────────── */

@media (prefers-reduced-motion: reduce) {
  .brand,
  .socialLink,
  .link {
    transition: none;
  }
  .socialLink:hover {
    transform: none;
  }
}
